import { useContext } from "react";

import { PartnerContext } from "./partner-provider";
import { LoadStyles } from "./theme/react";

import type { Partner } from "./partner-provider";

const mapPartnerStyles: Record<Partner, string> = {
  caut: "/tenant/theme.caut.css",
  clicassure: "/tenant/theme.clicassure.css",
  coopdestination: "/tenant/theme.coopdestination.css",
  coophydro: "/tenant/theme.coophydro.css",
  creditKarma: "",
  csbq: "/tenant/theme.csbq.css",
  dwm: "/tenant/theme.dwm.css",
  educfinance: "",
  eqb: "/tenant/theme.eqb.css",
  ferique: "/tenant/theme.ferique.css",
  fhg: "/tenant/theme.fhg.css",
  ia: "/tenant/theme.ia.css",
  ig: "/tenant/theme.ig.css",
  independents: "",
  ipc_pinnacle: "/tenant/theme.ipcc.css",
  ipcc: "/tenant/theme.ipcc.css",
  lpfinancial: "/tenant/theme.lpfinancial.css",
  moneydotca: "/tenant/theme.moneydotca.css",
  myabode: "/tenant/theme.myabode.css",
  optimize: "/tenant/theme.optimize.css",
  portfoliostrategies: "/tenant/theme.portfoliostrategies.css",
  psc: "/tenant/theme.psc.css",
  quadrus: "/tenant/theme.quadrus.css",
  rogersbank: "/tenant/theme.rogersbank.css",
  wahi: "/tenant/theme.wahi.css",
  wahi_realtor: "/tenant/theme.wahi_realtor.css",
  wealthSimple: "",
  nesto: ``, // empty no override for nesto
};

// Partner is not a tenant but a co-branding experience apply over the current tenant scheme
interface PartnerStylesProps {
  partnerSSR: Partner;
}

export const PartnerStyles = ({ partnerSSR }: PartnerStylesProps) => {
  const ctx = useContext(PartnerContext);
  const href = mapPartnerStyles[ctx?.partner || partnerSSR] || "";

  if (href) {
    return <LoadStyles id={`partner`} href={href} />;
  }
  return null;
};
